<template>
  <!-- 原型 HTML 还原正文；顶/底由门户 PortalNavbar + PortalFooter 提供 -->
  <div class="sol-is-hotel">
    <!-- ===== Hero ===== -->
    <section class="hero" id="hero">
      <div class="container">
        <div class="hero-grid">
          <div class="hero-content reveal active">
            <div class="hero-badge">
              <span class="dot"></span>
              <span>已服务 600+ 酒店集团 · 20,000+ 门店</span>
            </div>
            <h1>酒店行业SaaS解决方案<br><span class="highlight">打通前厅客房餐饮</span>，全域增收降本增效</h1>
            <p class="hero-sub">整合前台PMS、中央预订、线上渠道、会员、餐饮、客房、营销全链路，助力酒店集团与单体酒店实现数字化转型升级。从智慧房态到收益管理，从会员精细化运营到大数据经营决策，一个平台搞定全流程。</p>
            <div class="hero-tags">
              <span>智慧酒店</span>
              <span>会员运营</span>
              <span>中央预订</span>
              <span>收益管理</span>
              <span>数字化集团</span>
            </div>
            <div class="hero-cta">
              <button class="btn btn-primary btn-lg" @click="scrollToSection('cta')"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>立即预约演示</button>
            </div>
            <div class="hero-trust">
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">600+</div>
                  <div class="hero-trust-label">服务酒店</div>
                </div>
              </div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">99.9%</div>
                  <div class="hero-trust-label">系统可用性</div>
                </div>
              </div>
              <div class="hero-trust-divider"></div>
              <div class="hero-trust-item">
                <div>
                  <div class="hero-trust-num">7×24</div>
                  <div class="hero-trust-label">专属服务支持</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Dashboard Mockup -->
          <div class="hero-visual reveal reveal-delay-1 active">
            <div class="dash-mock">
              <div class="dash-bar">
                <div class="dots"><span></span><span></span><span></span></div>
                <div class="url">app.hotelcloud.com/dashboard</div>
              </div>
              <div class="dash-body">
                <div class="dash-side">
                  <div class="icon-item active"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="9"/><rect x="14" y="3" width="7" height="5"/><rect x="14" y="12" width="7" height="9"/><rect x="3" y="16" width="7" height="5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 21V9"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
                  <div class="icon-item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 22c0-4 4-7 8-7s8 3 8 7"/></svg></div>
                </div>
                <div class="dash-main">
                  <div class="dash-stats">
                    <div class="dash-stat">
                      <div class="dash-stat-label">今日营收</div>
                      <div class="dash-stat-val">¥986K</div>
                      <div class="dash-stat-trend up">↑ 18.6%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">入住率</div>
                      <div class="dash-stat-val">82.4%</div>
                      <div class="dash-stat-trend up">↑ 9.2%</div>
                    </div>
                    <div class="dash-stat">
                      <div class="dash-stat-label">新增会员</div>
                      <div class="dash-stat-val">742</div>
                      <div class="dash-stat-trend up">↑ 31.5%</div>
                    </div>
                  </div>
                  <div class="dash-chart">
                    <div class="dash-chart-head">
                      <div class="dash-chart-title">客房出租率趋势</div>
                      <div class="dash-chart-tag">近7日</div>
                    </div>
                    <div class="bars">
                      <div class="bar" style="height:55%"></div>
                      <div class="bar" style="height:68%"></div>
                      <div class="bar dim" style="height:42%"></div>
                      <div class="bar" style="height:79%"></div>
                      <div class="bar" style="height:63%"></div>
                      <div class="bar" style="height:91%"></div>
                      <div class="bar" style="height:96%"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dash-float dash-float-1">
              <div class="dash-float-icon green">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">全域同步</div>
                <div class="label">房态 · 订单 · 会员</div>
              </div>
            </div>
            <div class="dash-float dash-float-2">
              <div class="dash-float-icon blue">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
              </div>
              <div class="dash-float-text">
                <div class="num">收益提升 28%+</div>
                <div class="label">经营效率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Pain Points ===== -->
    <section class="section pain-section" id="pain">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">01 PAIN POINTS</div>
          <h2 class="section-title">酒店行业经营痛点</h2>
          <p class="section-subtitle">传统酒店在多渠道分销、房态管理、会员运营等方面存在诸多难题，严重制约酒店规模化与品牌化发展</p>
        </div>
        <div class="pain-grid">
          <div class="pain-card reveal">
            <div class="pain-num">01</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 12a9 9 0 11-6.219-8.56"/><path d="M22 4L12 14.01l-3-3"/></svg>
            </div>
            <h3 class="pain-title">渠道割裂脱节</h3>
            <p class="pain-desc">OTA、官网、小程序、前台、协议客户等多渠道订单互不互通，房态与库存分散，超售与漏单频发，难以统一精细化运营。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">02</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg>
            </div>
            <h3 class="pain-title">房态管理混乱</h3>
            <p class="pain-desc">多房型、多楼层、多门店房态靠人工维护，脏房、维修房、预离房状态更新滞后，前台与客房部信息不同步，入住体验受损。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">03</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3 class="pain-title">会员沉睡流失</h3>
            <p class="pain-desc">酒店会员体系弱、粘性差，缺乏客户分层与精准触达能力，协议散客、OTA客难沉淀，老客复购与口碑持续走低。</p>
          </div>
          <div class="pain-card reveal">
            <div class="pain-num">04</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg>
            </div>
            <h3 class="pain-title">经营决策模糊</h3>
            <p class="pain-desc">入住率、RevPAR、客源结构、渠道贡献、餐饮坪效等数据零散杂乱，无统一可视化看板，只能依靠经验定价，缺乏数据支撑。</p>
          </div>
          <div class="pain-card reveal reveal-delay-1">
            <div class="pain-num">05</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
            </div>
            <h3 class="pain-title">运营成本偏高</h3>
            <p class="pain-desc">依赖人工排房、对账、夜审、报表与渠道结算，人力成本高昂、效率低下，响应迟缓，且极易出现人为失误与财务漏损。</p>
          </div>
          <div class="pain-card reveal reveal-delay-2">
            <div class="pain-num">06</div>
            <div class="pain-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg>
            </div>
            <h3 class="pain-title">营销玩法单一</h3>
            <p class="pain-desc">缺少储值、权益卡、拼团、分销、直播等主流数字化营销工具，活动形式单一，难以适配节假日、淡旺季的拓客裂变场景。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Solution Overview ===== -->
    <section class="section solution-section" id="solution">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">02 SOLUTION OVERVIEW</div>
          <h2 class="section-title">解决方案总览</h2>
          <p class="section-subtitle">专为酒店集团、单体酒店、民宿与度假村打造的一体化SaaS数字化管理平台，全方位解决行业经营痛点</p>
        </div>
        <div class="solution-grid">
          <div class="solution-card reveal">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg>
            </div>
            <h3>方案简介</h3>
            <p>整合前台PMS、中央预订、会员、营销、餐饮、收益、数据全链路能力，打破系统壁垒，实现酒店全流程一体化数字化经营。</p>
          </div>
          <div class="solution-card reveal reveal-delay-1">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/><path d="M2 12h20"/></svg>
            </div>
            <h3>方案目标</h3>
            <p>实现线上线下一体化、经营数据可视化、会员运营精细化、收益管理动态化、集团管控智能化，助力酒店提质增效。</p>
          </div>
          <div class="solution-card reveal reveal-delay-2">
            <div class="solution-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>
            </div>
            <h3>适用对象</h3>
            <p>酒店集团、单体酒店、民宿客栈、度假村、公寓式酒店及多业态住宿运营商。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Core Functions ===== -->
    <section class="section func-section" id="features">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">03 CORE MODULES</div>
          <h2 class="section-title">核心功能模块</h2>
          <p class="section-subtitle">全链路数字化功能矩阵，覆盖酒店经营全场景，一站式解决酒店管理难题</p>
        </div>
        <div class="func-grid">
          <div class="func-card reveal">
            <div class="func-card-num">01</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg></div>
              <h3>全渠道中央预订系统（CRS）</h3>
              <p>统一对接携程、美团、飞猪、Booking等OTA与官网小程序，实时房态与价格同步，订单自动回传前台，彻底杜绝超售漏单，实现全渠道统一卖房。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">02</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></svg></div>
              <h3>智慧前台与房态管理（PMS）</h3>
              <p>支持快速入住退房、智能排房、房态实时同步、夜审自动结算、电子发票，适配多门店连锁模式，实现总部统一管控、门店独立精细运营。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">03</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></svg></div>
              <h3>会员数字化精细运营</h3>
              <p>统一会员档案，支持会员分级、积分、储值、权益卡、优惠券等功能，搭配客户标签、精准群发、复购提醒，深度激活酒店私域客户资产。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">04</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg></div>
              <h3>餐饮与客房服务管理</h3>
              <p>打通客房送餐、餐饮POS、迷你吧、康体娱乐等消费场景，挂账统一结算，支持扫码点单与客房服务一键呼叫，提升客单价与服务体验。</p>
            </div>
          </div>
          <div class="func-card reveal">
            <div class="func-card-num">05</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
              <h3>全域营销与分销</h3>
              <p>内置储值卡、权益卡、拼团、秒杀、分销、直播带货全套玩法，适配节假日、店庆、淡旺季各类场景，快速实现客户拉新与社交裂变拓客。</p>
            </div>
          </div>
          <div class="func-card reveal reveal-delay-1">
            <div class="func-card-num">06</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg></div>
              <h3>智能收益管理（RMS）</h3>
              <p>基于历史入住、渠道、节假日与竞争态势动态定价，自动测算最优房价与房量分配，提升RevPAR与出租率，让每一间客房收益最大化。</p>
            </div>
          </div>
          <div class="func-card reveal" style="grid-column:span 2">
            <div class="func-card-num">07</div>
            <div class="func-card-body">
              <div class="func-card-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 10h20"/><circle cx="8" cy="15" r="1"/><circle cx="12" cy="15" r="1"/><circle cx="16" cy="15" r="1"/></svg></div>
              <h3>大数据智能经营看板</h3>
              <p>自动统计营收、入住率、RevPAR、客源结构、渠道贡献、餐饮坪效等核心数据，可视化图表直观展示，助力酒店数据化科学决策。管理层随时掌握全域经营动态，按门店、房型、渠道、时段多维下钻分析，为定价策略、营销排期、会员运营提供量化依据，让酒店经营从此心中有数。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Core Advantages ===== -->
    <section class="section advantage-section" id="advantage">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">04 CORE ADVANTAGES</div>
          <h2 class="section-title">方案核心优势</h2>
          <p class="section-subtitle">区别于单一功能酒店系统，依托一体化SaaS平台优势，为酒店提供轻量化、全链路、可拓展的数字化解决方案</p>
        </div>
        <div class="advantage-grid">
          <div class="advantage-card reveal">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg></div>
            <h3>一体化闭环经营</h3>
            <p>PMS、CRS、会员、餐饮、收益、营销、数据全模块打通，单一系统完成酒店全流程经营，无需对接多个软件，告别系统割裂问题。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></div>
            <h3>轻量化SaaS部署</h3>
            <p>无需搭建服务器、无需复杂部署，开通即可使用，按需订阅付费，大幅降低酒店数字化转型门槛与成本。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-2">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg></div>
            <h3>全终端适配同步</h3>
            <p>适配电脑端、手机端、PMS前台端、客房平板、管理看板多终端，数据实时同步，随时随地掌握酒店经营，打破时空管理限制。</p>
          </div>
          <div class="advantage-card reveal">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg></div>
            <h3>高拓展可定制</h3>
            <p>支持对接支付、门锁、公安核验、OTA、发票及酒店现有ERP，可根据经营需求定制功能，适配单体到连锁酒店全阶段发展。</p>
          </div>
          <div class="advantage-card reveal reveal-delay-1">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 7L9 18l-5-5"/></svg></div>
            <h3>简单易上手操作</h3>
            <p>可视化简洁操作界面，无需专业技术能力，前台、客房、店长可快速上手，配套全程售后培训与指导服务。</p>
          </div>
          <div class="advantage-card featured reveal reveal-delay-2">
            <div class="advantage-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5M2 12l10 5 10-5"/></svg></div>
            <h3>开放生态 · 持续迭代</h3>
            <p>深度对接微信、支付宝、携程、美团、飞猪、银联、发票平台等主流生态，功能持续迭代升级，紧跟行业趋势与政策变化，确保酒店始终拥有最新、最强的数字化经营能力。</p>
          </div>
        </div>

        <div class="ai-architecture">
          <h3>紫金山 AI 酒店全域业务架构</h3>
          <p>以全域预订、统一经营中台、数据 AI 智能与开放生态，支撑酒店业务从预订到入住的完整闭环。</p>
          <div class="arch-map"><div class="arch-band"><div class="arch-band-label">全域预订层<small>在任意场景连接旅客</small></div><div class="arch-band-content"><div class="arch-unit"><i>官</i>官方预订<small>小程序 / APP</small></div><div class="arch-unit"><i>台</i>智慧前台<small>PMS / 自助</small></div><div class="arch-unit"><i>播</i>内容电商<small>直播 / 短视频</small></div><div class="arch-unit"><i>社</i>私域社群<small>企微 / 社群</small></div><div class="arch-unit"><i>OTA</i>分销平台<small>携程 / 美团</small></div><div class="arch-unit"><i>平</i>第三方平台<small>外部渠道</small></div></div></div><div class="arch-band core"><div class="arch-band-label">酒店经营中台<small>统一房态、预订与收益</small></div><div class="arch-band-content"><div class="arch-unit"><i>房</i>房态中心<small>PMS / 门锁</small></div><div class="arch-unit"><i>预</i>中央预订<small>CRS / 聚合</small></div><div class="arch-unit"><i>订</i>订单中心<small>入住 / 退订</small></div><div class="arch-unit"><i>益</i>收益管理<small>定价 / RMS</small></div><div class="arch-unit"><i>财</i>财务对账<small>收款 / 结算</small></div><div class="arch-unit"><i>服</i>履约服务<small>客房 / 餐饮</small></div></div></div><div class="arch-band"><div class="arch-band-label">客户增长中台<small>沉淀会员资产与复购</small></div><div class="arch-band-content"><div class="arch-unit"><i>会</i>会员资产<small>ID / 标签</small></div><div class="arch-unit"><i>权</i>权益积分<small>储值 / 券</small></div><div class="arch-unit"><i>营</i>营销自动化<small>触达 / 归因</small></div><div class="arch-unit"><i>导</i>导购助手<small>任务 / 激励</small></div><div class="arch-unit"><i>客</i>客服与售后<small>工单 / 满意度</small></div><div class="arch-unit"><i>分</i>分销裂变<small>邀请 / 返佣</small></div></div></div><div class="arch-band ai"><div class="arch-band-label">AI 数据智能<small>用数据驱动每一个决策</small></div><div class="arch-band-content"><div class="arch-unit"><i>AI</i>智能体<small>经营问答</small></div><div class="arch-unit"><i>AI</i>数字员工<small>任务协同</small></div><div class="arch-unit"><i>像</i>用户画像<small>洞察 / 分群</small></div><div class="arch-unit"><i>预</i>经营预测<small>销量 / 需求</small></div><div class="arch-unit"><i>算</i>算法应用<small>推荐 / 定价</small></div><div class="arch-unit"><i>看</i>数据驾驶舱<small>指标 / 预警</small></div></div></div><div class="arch-band"><div class="arch-band-label">开放与安全底座<small>连接生态，守护数据</small></div><div class="arch-band-content"><div class="arch-unit"><i>API</i>开放接口<small>标准接口</small></div><div class="arch-unit"><i>ERP</i>系统集成<small>财务 / 供应链</small></div><div class="arch-unit"><i>付</i>支付与物流<small>多服务商</small></div><div class="arch-unit"><i>权</i>权限管理<small>组织 / 角色</small></div><div class="arch-unit"><i>安</i>安全合规<small>加密 / 审计</small></div><div class="arch-unit"><i>云</i>稳定运行<small>备份 / 监控</small></div></div></div></div>
          <div class="arch-map-note"><b>紫金山 AI</b><span>用一套架构打通消费者、商品、门店、数据与 AI 能力。</span></div>
        </div>

      </div>
    </section>

    <!-- ===== Application Scenarios ===== -->
    <section class="section scenario-section" id="scenario">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">05 USE CASES</div>
          <h2 class="section-title">典型应用场景</h2>
          <p class="section-subtitle">贴合酒店全场景经营需求，全方位适配日常运营与拓客增收场景</p>
        </div>
        <div class="scenario-grid">
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 01</div>
            <h3>线上预订到店入住</h3>
            <p>引导OTA与官网客流沉淀私域会员，实现线上预订、到店快速入住，打通流量长效变现链路。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 02</div>
            <h3>多门店多品牌统一经营</h3>
            <p>整合集团旗下多品牌、多门店全渠道流量，统一管理订单、房态、会员与客户数据，提升整体运营效率。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 03</div>
            <h3>场景化营销裂变</h3>
            <p>快速搭建节假日、店庆、淡旺季促销活动，依托营销工具实现客户快速裂变拓客。</p>
          </div>
          <div class="scenario-card reveal">
            <div class="scenario-tag">场景 04</div>
            <h3>集团中央管控</h3>
            <p>总部统一管控价格、营销、会员体系，各门店独立运营，经营数据统一汇总分析。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-1">
            <div class="scenario-tag">场景 05</div>
            <h3>私域会员长效运营</h3>
            <p>全方位沉淀客户资产，通过精细化分层运营、精准触达，持续提升客户粘性与复购率。</p>
          </div>
          <div class="scenario-card reveal reveal-delay-2">
            <div class="scenario-tag">场景 06</div>
            <h3>直播短视频带货</h3>
            <p>直播卖房券、套餐券，对接抖音快手等平台，订单实时回传系统，房态自动锁定，实现高效履约。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Customer Value ===== -->
    <section class="section value-section" id="value">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">06 CUSTOMER VALUE</div>
          <h2 class="section-title">客户落地价值</h2>
          <p class="section-subtitle">量化数字化转型成果，实实在在为酒店降本、增效、增收</p>
        </div>
        <div class="value-grid">
          <div class="value-card reveal">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
            <h3>运营效率大幅提升</h3>
            <p>自动化替代人工操作，排房、对账、夜审、报表等核心工作效率显著提升。</p>
            <div class="value-highlight">成本降低 30%-60%</div>
          </div>
          <div class="value-card reveal reveal-delay-1">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 3v18h18"/><path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14"/></svg></div>
            <h3>整体营收稳步增长</h3>
            <p>依托全域营销与会员精细化运营，助力酒店新客裂变增长、老客复购提升。</p>
            <div class="value-highlight">营收提升 20%-50%</div>
          </div>
          <div class="value-card reveal reveal-delay-2">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg></div>
            <h3>经营风险有效降低</h3>
            <p>精准化渠道对账、智能房态锁定，有效减少超售漏单、财务漏损等经营损耗。</p>
            <div class="value-highlight">损耗减少 40%+</div>
          </div>
          <div class="value-card reveal reveal-delay-3">
            <div class="value-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg></div>
            <h3>科学数据化决策</h3>
            <p>全维度经营数据可视化呈现，告别经验式经营，实现数据驱动的精准运营与战略决策。</p>
            <div class="value-highlight">决策效率 80%↑</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Trust Section ===== -->
    <section class="trust-section" id="trust">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">07 TRUST & RECOGNITION</div>
          <h2 class="section-title">品牌信任背书</h2>
          <p class="section-subtitle">600+ 酒店集团与连锁酒店的共同选择，权威认证护航，生态合作共建数字化未来</p>
        </div>
        <div class="trust-stats reveal">
          <div class="trust-stat">
            <div class="num">600<span class="unit">+</span></div>
            <div class="label">服务酒店</div>
          </div>
          <div class="trust-stat">
            <div class="num">20,000<span class="unit">+</span></div>
            <div class="label">酒店门店</div>
          </div>
          <div class="trust-stat">
            <div class="num">99.9<span class="unit">%</span></div>
            <div class="label">系统可用性</div>
          </div>
          <div class="trust-stat">
            <div class="num">7×24</div>
            <div class="label">专属服务</div>
          </div>
        </div>
        <div class="logo-wall reveal">
          <div class="logo-wall-title">TRUSTED BY LEADING HOTELS</div>
          <div class="logo-grid">
            <div class="logo-item">锦江酒店</div>
            <div class="logo-item">华住集团</div>
            <div class="logo-item">首旅如家</div>
            <div class="logo-item">亚朵</div>
            <div class="logo-item">希尔顿</div>
            <div class="logo-item">万豪</div>
            <div class="logo-item">洲际</div>
            <div class="logo-item">凯悦</div>
            <div class="logo-item">尚美数智</div>
            <div class="logo-item">万达酒店</div>
            <div class="logo-item">格林酒店</div>
            <div class="logo-item">君亭酒店</div>
          </div>
        </div>
        <div class="trust-cert reveal">
          <div class="cert-card">
            <div class="cert-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg></div>
            <div class="cert-info">
              <div class="title">ISO 27001 信息安全认证</div>
              <div class="desc">国际权威信息安全管理体系认证</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/><path d="M3 9h18"/></svg></div>
            <div class="cert-info">
              <div class="title">等保三级认证</div>
              <div class="desc">国家信息安全等级保护三级资质</div>
            </div>
          </div>
          <div class="cert-card">
            <div class="cert-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2L2 7v10l10 5 10-5V7L12 2z"/><path d="M2 7l10 5 10-5M12 22V12"/></svg></div>
            <div class="cert-info">
              <div class="title">高新技术企业</div>
              <div class="desc">国家级高新技术企业资质认证</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== FAQ ===== -->
    <section class="section faq-section" id="faq">
      <div class="container">
        <div class="section-head center reveal">
          <div class="section-num">08 FAQ</div>
          <h2 class="section-title">常见问题</h2>
          <p class="section-subtitle">解答酒店用户高频疑问，打消合作顾虑</p>
        </div>
        <div class="faq-wrap reveal">
          <div class="faq-item">
            <div class="faq-q">
              <span>系统是否需要复杂部署？支持免费试用吗？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">本系统为SaaS轻量化模式，无需服务器部署、无需专业运维，开通账号即可使用，平台支持免费试用、预约演示服务。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>能否对接现有PMS、门锁、OTA与支付系统？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">系统具备高拓展接口，可无缝对接主流聚合支付（微信、支付宝、银联等）、智能门锁、公安核验、电子发票及酒店现有PMS，实现数据互通与统一管理。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>多门店、多品牌、多员工如何设置权限管理？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">支持精细化权限分级，可自定义集团、门店、前台、客房、店长不同操作权限，适配酒店多层级管理需求。支持角色模板、数据隔离、操作日志等企业级管控能力。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>房态与多渠道订单如何自动同步防超售？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">系统通过中央预订引擎（CRS）实时同步各渠道房态与价格，订单自动回传前台并锁定房量，自动处理满房与关房，从根源杜绝超售漏单与渠道冲突。</div>
            </div>
          </div>
          <div class="faq-item">
            <div class="faq-q">
              <span>是否提供售后培训和技术支持？</span>
              <svg class="arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>
            </div>
            <div class="faq-a">
              <div class="faq-a-inner">提供7×24小时技术支持，专属客服一对一服务，配套完整的操作培训、使用教程，全程保驾护航。新酒店上线首月提供专属实施顾问免费指导。</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== Final CTA ===== -->
    <section class="cta-section" id="cta">
      <div class="container">
        <div class="cta-inner reveal">
          <h2>助力酒店集团<span class="highlight">数字化转型升级</span></h2>
          <p>全域一体化智慧经营，降本增效、全域增收，开启酒店数字化新征程</p>
          <div class="cta-options">
              <a class="btn btn-primary btn-lg" href="#" role="button" @click.prevent="openCustomerService">咨询详情</a>
            </div>
          <div class="cta-note">
            <span>7×24小时技术支持</span>
            <span class="dot"></span>
            <span>一对一专属服务</span>
            <span class="dot"></span>
            <span>免费落地培训指导</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { openCustomerService } from '../../openCustomerService'
defineOptions({ name: 'PortalIsHotel' })

let revealIo: IntersectionObserver | null = null

function scrollToSection(id: string) {
  const el = document.getElementById(id)
  if (!el) return
  const scroller = document.querySelector('.portal-page') as HTMLElement | null
  if (scroller) {
    const top =
      el.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - 12
    scroller.scrollTo({ top, behavior: 'smooth' })
    return
  }
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 72, behavior: 'smooth' })
}

function bindFaq() {
  const rootEl = document.querySelector('.sol-is-hotel')
  if (!rootEl) return
  rootEl.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q') as HTMLElement | null
    const a = item.querySelector('.faq-a') as HTMLElement | null
    if (!q || !a) return
    a.style.maxHeight = '0'
    q.onclick = () => {
      const isActive = item.classList.contains('active')
      rootEl.querySelectorAll('.faq-item').forEach((other) => {
        other.classList.remove('active')
        const oa = other.querySelector('.faq-a') as HTMLElement | null
        if (oa) oa.style.maxHeight = '0'
      })
      if (!isActive) {
        item.classList.add('active')
        a.style.maxHeight = a.scrollHeight + 'px'
      }
    }
  })
}

function bindReveal() {
  const nodes = document.querySelectorAll('.sol-is-hotel .reveal')
  revealIo = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('active')
      })
    },
    { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
  )
  nodes.forEach((n) => revealIo!.observe(n))
}

function bindBars() {
  const bars = document.querySelectorAll('.sol-is-hotel .bars .bar')
  bars.forEach((bar, i) => {
    const el = bar as HTMLElement
    const h = el.style.height
    if (!h) return
    el.style.height = '0'
    window.setTimeout(() => {
      el.style.transition = `height .8s ease ${i * 0.08}s`
      el.style.height = h
    }, 100)
  })
}

onMounted(() => {
  bindFaq()
  bindReveal()
  bindBars()
})

onBeforeUnmount(() => {
  revealIo?.disconnect()
  revealIo = null
})
</script>

<style lang="scss">

/* ===== Reset & Base ===== */
.sol-is-hotel,.sol-is-hotel *,.sol-is-hotel *::before,.sol-is-hotel *::after{margin:0;padding:0;box-sizing:border-box}
.sol-is-hotel{
  --c-primary:#1e88e5;
  --c-primary-2:#1976d2;
  --c-primary-3:#1565c0;
  --c-primary-4:#0d47a1;
  --c-primary-light:#42a5f5;
  --c-primary-bright:#2196f3;
  --c-cyan:#06b6d4;
  --c-slate:#475569;
  --c-slate-light:#64748b;
  --c-text:#0f172a;
  --c-text-mid:#334155;
  --c-bg:#f5f9ff;
  --c-bg-2:#eef4fc;
  --c-bg-3:#e8f1fb;
  --c-border:#e2e8f0;
  --c-white:#fff;
  --c-footer:#0a1929;
  --c-footer-2:#0d2238;
  --radius:14px;
  --radius-lg:22px;
  --shadow-sm:0 2px 8px rgba(30,136,229,.08);
  --shadow:0 8px 28px rgba(30,136,229,.10);
  --shadow-lg:0 18px 56px rgba(30,136,229,.14);
  --shadow-xl:0 28px 80px rgba(30,136,229,.18);
  --shadow-blue:0 10px 30px rgba(30,136,229,.35);
  --max-w:1280px;
  --font:-apple-system,BlinkMacSystemFont,"Segoe UI","PingFang SC","Hiragino Sans GB","Microsoft YaHei",sans-serif;
}
.sol-is-hotel{scroll-behavior:smooth;font-size:16px}
.sol-is-hotel{font-family:var(--font);color:var(--c-text);background:var(--c-white);line-height:1.7;overflow-x:hidden;-webkit-font-smoothing:antialiased}
.sol-is-hotel a{text-decoration:none;color:inherit}
.sol-is-hotel img{max-width:100%;display:block}
.sol-is-hotel ul{list-style:none}
.sol-is-hotel .container{max-width:var(--max-w);margin:0 auto;padding:0 24px}
.sol-is-hotel .section{padding:110px 0;position:relative}
.sol-is-hotel .section-sm{padding:72px 0}

/* ===== Typography ===== */
.sol-is-hotel .eyebrow{font-size:.8rem;font-weight:700;letter-spacing:.2em;text-transform:uppercase;color:var(--c-primary);margin-bottom:12px}
.sol-is-hotel .section-num{font-size:.82rem;font-weight:800;letter-spacing:.18em;color:var(--c-primary);display:inline-block;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:6px 14px;border-radius:100px;margin-bottom:14px}
.sol-is-hotel .section-title{font-size:2.4rem;font-weight:800;color:var(--c-text);line-height:1.25;margin-bottom:18px;letter-spacing:-.02em}
.sol-is-hotel .section-subtitle{font-size:1.08rem;color:var(--c-slate);max-width:720px;line-height:1.8}
.sol-is-hotel .section-head{margin-bottom:64px}
.sol-is-hotel .section-head.center{text-align:center}
.sol-is-hotel .section-head.center .section-subtitle{margin:0 auto}
.sol-is-hotel .section-head.center .section-num{display:inline-block}

/* ===== 3D Buttons ===== */
.sol-is-hotel .btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;padding:12px 28px;border-radius:12px;font-size:.94rem;font-weight:600;cursor:pointer;border:none;transition:all .25s;white-space:nowrap;line-height:1.2}
.sol-is-hotel .btn-primary{background:linear-gradient(180deg,#42a5f5 0%,#1e88e5 50%,#1976d2 100%);color:#fff;
  box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 4px 0 var(--c-primary-3),0 8px 20px rgba(30,136,229,.35)}
.sol-is-hotel .btn-primary:hover{transform:translateY(-2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 6px 0 var(--c-primary-3),0 12px 26px rgba(30,136,229,.45)}
.sol-is-hotel .btn-primary:active{transform:translateY(2px);box-shadow:inset 0 1px 0 rgba(255,255,255,.4),inset 0 -2px 0 rgba(0,0,0,.08),0 1px 0 var(--c-primary-3),0 4px 12px rgba(30,136,229,.35)}
.sol-is-hotel .btn-outline{background:#fff;color:var(--c-primary-3);border:1.5px solid var(--c-border);box-shadow:0 4px 12px rgba(30,136,229,.08)}
.sol-is-hotel .btn-outline:hover{border-color:var(--c-primary);color:var(--c-primary);box-shadow:0 6px 18px rgba(30,136,229,.18);transform:translateY(-2px)}
.sol-is-hotel .btn-ghost{background:rgba(255,255,255,.14);color:#fff;border:1px solid rgba(255,255,255,.35);backdrop-filter:blur(6px)}
.sol-is-hotel .btn-ghost:hover{background:rgba(255,255,255,.24);transform:translateY(-2px)}
.sol-is-hotel .btn-lg{padding:17px 40px;font-size:1.05rem;border-radius:14px}
.sol-is-hotel .btn-lg.btn-primary{box-shadow:inset 0 1px 0 rgba(255,255,255,.45),inset 0 -2px 0 rgba(0,0,0,.1),0 6px 0 var(--c-primary-3),0 12px 28px rgba(30,136,229,.4)}
.sol-is-hotel .btn-sm{padding:9px 20px;font-size:.85rem;border-radius:10px}

/* ===== Hero ===== */
.sol-is-hotel .hero{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 30%,#1e88e5 70%,#2196f3 100%);padding:110px 0 100px;overflow:hidden}
.sol-is-hotel .hero::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 15% 40%,rgba(255,255,255,.18) 0%,transparent 45%),radial-gradient(circle at 85% 25%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 70% 80%,rgba(255,255,255,.1) 0%,transparent 40%);pointer-events:none}
.sol-is-hotel .hero::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:80px;background:linear-gradient(to bottom,transparent,var(--c-white));pointer-events:none}
.sol-is-hotel .hero-grid{display:grid;grid-template-columns:1.1fr .9fr;gap:56px;align-items:center;position:relative;z-index:1}
.sol-is-hotel .hero-badge{display:inline-flex;align-items:center;gap:10px;padding:8px 18px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.25);border-radius:100px;color:#fff;font-size:.82rem;font-weight:500;margin-bottom:30px;backdrop-filter:blur(8px)}
.sol-is-hotel .hero-badge .dot{width:8px;height:8px;background:#34d399;border-radius:50%;box-shadow:0 0 10px #34d399;animation:pulse 1.6s ease-in-out infinite}
@keyframes pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.6;transform:scale(1.3)}}
.sol-is-hotel .hero h1{font-size:3.2rem;font-weight:900;color:#fff;line-height:1.18;letter-spacing:-.025em;margin-bottom:24px}
.sol-is-hotel .hero h1 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;position:relative;display:inline-block}
.sol-is-hotel .hero h1 .highlight::after{content:"";position:absolute;left:0;right:0;bottom:-4px;height:6px;background:linear-gradient(90deg,#fff 0%,rgba(255,255,255,.2) 100%);border-radius:3px;opacity:.5}
.sol-is-hotel .hero-sub{font-size:1.14rem;color:rgba(255,255,255,.85);line-height:1.85;margin-bottom:28px;max-width:560px}
.sol-is-hotel .hero-tags{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:36px}
.sol-is-hotel .hero-tags span{padding:7px 16px;border:1px solid rgba(255,255,255,.3);border-radius:30px;font-size:.8rem;color:rgba(255,255,255,.85);background:rgba(255,255,255,.06);backdrop-filter:blur(4px)}
.sol-is-hotel .hero-cta{display:flex;gap:16px;margin-bottom:40px;flex-wrap:wrap}
.sol-is-hotel .hero-trust{display:flex;align-items:center;gap:30px;flex-wrap:wrap}
.sol-is-hotel .hero-trust-item{display:flex;align-items:center;gap:10px}
.sol-is-hotel .hero-trust-num{font-size:1.65rem;font-weight:800;color:#fff}
.sol-is-hotel .hero-trust-label{font-size:.82rem;color:rgba(255,255,255,.6)}
.sol-is-hotel .hero-trust-divider{width:1px;height:40px;background:rgba(255,255,255,.18)}

/* Hero Dashboard Mockup */
.sol-is-hotel .hero-visual{position:relative}
.sol-is-hotel .dash-mock{background:#fff;border-radius:18px;box-shadow:0 40px 90px rgba(0,30,80,.45);overflow:hidden;border:1px solid rgba(255,255,255,.2)}
.sol-is-hotel .dash-bar{display:flex;align-items:center;gap:8px;padding:14px 18px;background:#f0f7ff;border-bottom:1px solid var(--c-border)}
.sol-is-hotel .dash-bar .dots{display:flex;gap:6px}
.sol-is-hotel .dash-bar .dots span{width:10px;height:10px;border-radius:50%}
.sol-is-hotel .dash-bar .dots span:nth-child(1){background:#ef4444}
.sol-is-hotel .dash-bar .dots span:nth-child(2){background:#f59e0b}
.sol-is-hotel .dash-bar .dots span:nth-child(3){background:#22c55e}
.sol-is-hotel .dash-bar .url{flex:1;text-align:center;font-size:.72rem;color:var(--c-slate-light);background:#fff;border:1px solid var(--c-border);border-radius:6px;padding:4px 14px;margin-left:8px}
.sol-is-hotel .dash-body{display:grid;grid-template-columns:68px 1fr;min-height:360px}
.sol-is-hotel .dash-side{background:linear-gradient(180deg,#0d47a1,#1565c0);padding:16px 0;display:flex;flex-direction:column;align-items:center;gap:16px}
.sol-is-hotel .dash-side .icon-item{width:40px;height:40px;border-radius:10px;display:flex;align-items:center;justify-content:center;color:rgba(255,255,255,.5);transition:.2s}
.sol-is-hotel .dash-side .icon-item.active{background:linear-gradient(135deg,#42a5f5,#1e88e5);color:#fff;box-shadow:0 4px 12px rgba(30,136,229,.5)}
.sol-is-hotel .dash-side .icon-item svg{width:18px;height:18px}
.sol-is-hotel .dash-main{padding:20px;background:#fafbfc}
.sol-is-hotel .dash-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px}
.sol-is-hotel .dash-stat{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:14px;transition:.2s}
.sol-is-hotel .dash-stat:hover{border-color:var(--c-primary-light);box-shadow:0 4px 12px rgba(30,136,229,.1)}
.sol-is-hotel .dash-stat-label{font-size:.68rem;color:var(--c-slate-light);margin-bottom:4px}
.sol-is-hotel .dash-stat-val{font-size:1.2rem;font-weight:800;color:var(--c-text)}
.sol-is-hotel .dash-stat-trend{font-size:.65rem;font-weight:700;margin-top:3px}
.sol-is-hotel .up{color:#10b981}
.sol-is-hotel .dn{color:#ef4444}
.sol-is-hotel .dash-chart{background:#fff;border:1px solid var(--c-border);border-radius:12px;padding:16px}
.sol-is-hotel .dash-chart-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px}
.sol-is-hotel .dash-chart-title{font-size:.74rem;font-weight:600;color:var(--c-text)}
.sol-is-hotel .dash-chart-tag{font-size:.62rem;color:var(--c-primary);background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));padding:3px 10px;border-radius:100px;font-weight:600}
.sol-is-hotel .bars{display:flex;align-items:flex-end;gap:6px;height:96px}
.sol-is-hotel .bar{flex:1;border-radius:4px 4px 0 0;background:linear-gradient(180deg,#42a5f5,#1565c0);opacity:.9;transition:opacity .2s}
.sol-is-hotel .bar:hover{opacity:1}
.sol-is-hotel .bar.dim{background:linear-gradient(180deg,#cbd5e1,#94a3b8)}
.sol-is-hotel .dash-float{position:absolute;background:#fff;border-radius:14px;box-shadow:0 14px 36px rgba(0,30,80,.25);padding:14px 18px;display:flex;align-items:center;gap:14px;animation:float 3.5s ease-in-out infinite;border:1px solid rgba(255,255,255,.6)}
.sol-is-hotel .dash-float-1{top:-20px;right:-12px;animation-delay:0s}
.sol-is-hotel .dash-float-2{bottom:-18px;left:-18px;animation-delay:1.5s}
.sol-is-hotel .dash-float-icon{width:42px;height:42px;border-radius:12px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.sol-is-hotel .dash-float-icon.green{background:linear-gradient(135deg,#d1fae5,#a7f3d0);color:#10b981}
.sol-is-hotel .dash-float-icon.blue{background:linear-gradient(135deg,#dbeafe,#bfdbfe);color:#1e88e5}
.sol-is-hotel .dash-float-text .num{font-size:1.05rem;font-weight:800;color:var(--c-text)}
.sol-is-hotel .dash-float-text .label{font-size:.7rem;color:var(--c-slate-light)}
@keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}

/* ===== Pain Points ===== */
.sol-is-hotel .pain-section{background:linear-gradient(180deg,var(--c-white),var(--c-bg))}
.sol-is-hotel .pain-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-is-hotel .pain-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 30px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-hotel .pain-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-xl);transform:translateY(-6px)}
.sol-is-hotel .pain-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-is-hotel .pain-card:hover::before{transform:scaleX(1)}
.sol-is-hotel .pain-num{position:absolute;top:24px;right:28px;font-size:2.8rem;font-weight:900;color:rgba(30,136,229,.06);line-height:1}
.sol-is-hotel .pain-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.15)}
.sol-is-hotel .pain-icon svg{width:28px;height:28px;color:var(--c-primary-2)}
.sol-is-hotel .pain-title{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-hotel .pain-desc{font-size:.92rem;color:var(--c-slate);line-height:1.8}

/* ===== Solution Overview ===== */
.sol-is-hotel .solution-section{background:#fff}
.sol-is-hotel .solution-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:28px}
.sol-is-hotel .solution-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:40px 32px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-hotel .solution-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-is-hotel .solution-card::after{content:"";position:absolute;top:-30px;right:-30px;width:120px;height:120px;background:radial-gradient(circle,rgba(30,136,229,.1),transparent);pointer-events:none}
.sol-is-hotel .solution-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:22px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-is-hotel .solution-icon svg{width:26px;height:26px;color:#fff}
.sol-is-hotel .solution-card h3{font-size:1.25rem;font-weight:700;color:var(--c-text);margin-bottom:14px}
.sol-is-hotel .solution-card p{font-size:.95rem;color:var(--c-slate);line-height:1.8}

/* ===== Core Functions ===== */
.sol-is-hotel .func-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}
.sol-is-hotel .func-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:24px}
.sol-is-hotel .func-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 32px;transition:all .3s;position:relative;overflow:hidden;display:flex;gap:24px}
.sol-is-hotel .func-card:hover{border-color:var(--c-primary-light);box-shadow:var(--shadow-lg);transform:translateY(-4px)}
.sol-is-hotel .func-card::before{content:"";position:absolute;left:0;top:0;bottom:0;width:4px;background:linear-gradient(180deg,#1e88e5,#42a5f5);transform:scaleY(0);transform-origin:top;transition:transform .4s}
.sol-is-hotel .func-card:hover::before{transform:scaleY(1)}
.sol-is-hotel .func-card-num{font-size:2.4rem;font-weight:900;color:rgba(30,136,229,.12);line-height:1;flex-shrink:0;min-width:56px}
.sol-is-hotel .func-card-body{flex:1}
.sol-is-hotel .func-card-icon{width:44px;height:44px;border-radius:11px;background:linear-gradient(135deg,#e3f2fd,#bbdefb);display:flex;align-items:center;justify-content:center;margin-bottom:16px;box-shadow:0 4px 12px rgba(30,136,229,.12)}
.sol-is-hotel .func-card-icon svg{width:22px;height:22px;color:var(--c-primary-2)}
.sol-is-hotel .func-card-body h3{font-size:1.2rem;font-weight:700;color:var(--c-text);margin-bottom:10px}
.sol-is-hotel .func-card-body p{font-size:.92rem;color:var(--c-slate);line-height:1.8}

/* ===== Core Advantages ===== */
.sol-is-hotel .advantage-section{background:#fff}
.sol-is-hotel .advantage-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-is-hotel .advantage-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:34px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-hotel .advantage-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-is-hotel .advantage-card::before{content:"";position:absolute;bottom:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#1e88e5,#42a5f5);transform:scaleX(0);transform-origin:left;transition:transform .4s}
.sol-is-hotel .advantage-card:hover::before{transform:scaleX(1)}
.sol-is-hotel .advantage-icon{width:48px;height:48px;border-radius:12px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin-bottom:20px;box-shadow:0 6px 16px rgba(30,136,229,.25)}
.sol-is-hotel .advantage-icon svg{width:24px;height:24px;color:#fff}
.sol-is-hotel .advantage-card h3{font-size:1.12rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-hotel .advantage-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-is-hotel .advantage-card.featured{grid-column:span 3;background:linear-gradient(135deg,#0d47a1,#1565c0);border:none}
.sol-is-hotel .advantage-card.featured h3{color:#fff}
.sol-is-hotel .advantage-card.featured p{color:rgba(255,255,255,.75)}
.sol-is-hotel .advantage-card.featured .advantage-icon{background:rgba(255,255,255,.15);box-shadow:none}
.sol-is-hotel .advantage-card.featured .advantage-icon svg{color:#90caf9}
.sol-is-hotel .advantage-card.featured::before{display:none}

/* ===== Application Scenarios ===== */
.sol-is-hotel .scenario-section{background:linear-gradient(180deg,var(--c-bg),var(--c-bg-2))}
.sol-is-hotel .scenario-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px}
.sol-is-hotel .scenario-card{background:#fff;border:1px solid var(--c-border);border-radius:var(--radius);padding:32px 28px;transition:all .3s;position:relative;overflow:hidden}
.sol-is-hotel .scenario-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-4px);border-color:var(--c-primary-light)}
.sol-is-hotel .scenario-tag{display:inline-block;padding:5px 12px;background:linear-gradient(135deg,rgba(30,136,229,.1),rgba(66,165,245,.1));color:var(--c-primary);font-size:.72rem;font-weight:700;border-radius:100px;margin-bottom:16px}
.sol-is-hotel .scenario-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-hotel .scenario-card p{font-size:.9rem;color:var(--c-slate);line-height:1.75}
.sol-is-hotel .scenario-card::after{content:"";position:absolute;bottom:-20px;right:-20px;width:80px;height:80px;background:radial-gradient(circle,rgba(30,136,229,.06),transparent);pointer-events:none}

/* ===== Customer Value ===== */
.sol-is-hotel .value-section{background:#fff}
.sol-is-hotel .value-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px}
.sol-is-hotel .value-card{background:linear-gradient(145deg,#f5f9ff,#e8f1fb);border:1px solid var(--c-border);border-radius:var(--radius-lg);padding:36px 26px;text-align:center;transition:all .3s;position:relative;overflow:hidden}
.sol-is-hotel .value-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-6px)}
.sol-is-hotel .value-card::before{content:"";position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1e88e5,#42a5f5,#06b6d4);transform:scaleX(0);transform-origin:center;transition:transform .4s}
.sol-is-hotel .value-card:hover::before{transform:scaleX(1)}
.sol-is-hotel .value-icon{width:56px;height:56px;border-radius:14px;background:linear-gradient(135deg,#1e88e5,#42a5f5);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;box-shadow:0 8px 20px rgba(30,136,229,.3)}
.sol-is-hotel .value-icon svg{width:28px;height:28px;color:#fff}
.sol-is-hotel .value-card h3{font-size:1.1rem;font-weight:700;color:var(--c-text);margin-bottom:12px}
.sol-is-hotel .value-card p{font-size:.88rem;color:var(--c-slate);line-height:1.75}
.sol-is-hotel .value-highlight{display:inline-block;margin-top:14px;padding:5px 14px;background:#fff;border:1px solid var(--c-primary-light);border-radius:100px;font-size:.78rem;font-weight:700;color:var(--c-primary)}

/* ===== Trust Section ===== */
.sol-is-hotel .trust-section{background:linear-gradient(135deg,#0a3a7a 0%,#0d47a1 50%,#1565c0 100%);position:relative;overflow:hidden;padding:100px 0}
.sol-is-hotel .trust-section::before{content:"";position:absolute;top:-50%;right:-10%;width:600px;height:600px;background:radial-gradient(circle,rgba(66,165,245,.15) 0%,transparent 70%);pointer-events:none}
.sol-is-hotel .trust-section::after{content:"";position:absolute;bottom:0;left:0;right:0;height:1px;background:linear-gradient(90deg,transparent,rgba(255,255,255,.1),transparent)}
.sol-is-hotel .trust-section .section-title{color:#fff}
.sol-is-hotel .trust-section .section-subtitle{color:rgba(255,255,255,.7)}
.sol-is-hotel .trust-section .section-num{color:#90caf9;background:rgba(255,255,255,.1)}
.sol-is-hotel .trust-stats{display:grid;grid-template-columns:repeat(4,1fr);gap:24px;margin-bottom:60px}
.sol-is-hotel .trust-stat{text-align:center;padding:36px 22px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);transition:.3s;backdrop-filter:blur(6px)}
.sol-is-hotel .trust-stat:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.18);transform:translateY(-6px)}
.sol-is-hotel .trust-stat .num{font-size:2.8rem;font-weight:900;color:#fff;letter-spacing:-.025em;line-height:1;margin-bottom:8px}
.sol-is-hotel .trust-stat .num .unit{font-size:1.4rem;font-weight:700}
.sol-is-hotel .trust-stat .label{font-size:.88rem;color:rgba(255,255,255,.55);font-weight:500}
.sol-is-hotel .logo-wall{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius-lg);padding:44px;margin-bottom:48px;backdrop-filter:blur(6px)}
.sol-is-hotel .logo-wall-title{text-align:center;font-size:.82rem;color:rgba(255,255,255,.45);letter-spacing:.18em;text-transform:uppercase;margin-bottom:28px;font-weight:600}
.sol-is-hotel .logo-grid{display:grid;grid-template-columns:repeat(6,1fr);gap:18px}
.sol-is-hotel .logo-item{height:64px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.08);border-radius:12px;display:flex;align-items:center;justify-content:center;font-size:.82rem;font-weight:700;color:rgba(255,255,255,.4);transition:.3s}
.sol-is-hotel .logo-item:hover{background:rgba(255,255,255,.08);color:rgba(255,255,255,.8);border-color:rgba(255,255,255,.18);transform:translateY(-2px)}
.sol-is-hotel .trust-cert{display:grid;grid-template-columns:repeat(3,1fr);gap:22px}
.sol-is-hotel .cert-card{background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);border-radius:var(--radius);padding:28px;display:flex;align-items:center;gap:18px;transition:.3s;backdrop-filter:blur(6px)}
.sol-is-hotel .cert-card:hover{background:rgba(255,255,255,.08);transform:translateY(-3px)}
.sol-is-hotel .cert-icon{width:52px;height:52px;border-radius:12px;background:linear-gradient(135deg,rgba(66,165,245,.2),rgba(30,136,229,.2));display:flex;align-items:center;justify-content:center;flex-shrink:0;border:1px solid rgba(66,165,245,.3)}
.sol-is-hotel .cert-icon svg{width:26px;height:26px;color:#90caf9}
.sol-is-hotel .cert-info .title{font-size:.92rem;font-weight:700;color:#fff;margin-bottom:4px}
.sol-is-hotel .cert-info .desc{font-size:.78rem;color:rgba(255,255,255,.45)}

/* ===== FAQ ===== */
.sol-is-hotel .faq-section{background:linear-gradient(180deg,var(--c-bg),var(--c-white))}
.sol-is-hotel .faq-wrap{max-width:880px;margin:0 auto}
.sol-is-hotel .faq-item{border:1.5px solid var(--c-border);border-radius:var(--radius);margin-bottom:14px;overflow:hidden;transition:.3s;background:#fff}
.sol-is-hotel .faq-item.active{border-color:var(--c-primary);box-shadow:0 8px 28px rgba(30,136,229,.12)}
.sol-is-hotel .faq-item.active .faq-q{color:var(--c-primary)}
.sol-is-hotel .faq-q{display:flex;align-items:center;justify-content:space-between;padding:22px 28px;cursor:pointer;font-size:1rem;font-weight:600;color:var(--c-text);transition:color .2s;user-select:none;gap:16px}
.sol-is-hotel .faq-q .arrow{width:22px;height:22px;flex-shrink:0;transition:transform .3s;color:var(--c-slate-light)}
.sol-is-hotel .faq-item.active .faq-q .arrow{transform:rotate(180deg);color:var(--c-primary)}
.sol-is-hotel .faq-a{max-height:0;overflow:hidden;transition:max-height .4s ease}
.sol-is-hotel .faq-a-inner{padding:0 28px 24px;font-size:.94rem;color:var(--c-slate);line-height:1.85}

/* ===== Final CTA ===== */
.sol-is-hotel .cta-section{position:relative;background:linear-gradient(135deg,#0d47a1 0%,#1565c0 50%,#1e88e5 100%);padding:100px 0;overflow:hidden}
.sol-is-hotel .cta-section::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background-image:radial-gradient(circle at 70% 30%,rgba(66,165,245,.25) 0%,transparent 50%),radial-gradient(circle at 20% 80%,rgba(255,255,255,.12) 0%,transparent 40%);pointer-events:none}
.sol-is-hotel .cta-section::after{content:"";position:absolute;bottom:-1px;left:0;right:0;height:60px;background:linear-gradient(to bottom,transparent,var(--c-footer));pointer-events:none}
.sol-is-hotel .cta-inner{position:relative;z-index:1;text-align:center;max-width:820px;margin:0 auto}
.sol-is-hotel .cta-inner h2{font-size:2.5rem;font-weight:900;color:#fff;letter-spacing:-.025em;margin-bottom:20px;line-height:1.25}
.sol-is-hotel .cta-inner h2 .highlight{background:linear-gradient(135deg,#fff,#bbdefb);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text}
.sol-is-hotel .cta-inner p{font-size:1.12rem;color:rgba(255,255,255,.8);line-height:1.85;margin-bottom:44px}
.sol-is-hotel .cta-options{display:flex;gap:18px;justify-content:center;flex-wrap:wrap;margin-bottom:36px}
.sol-is-hotel .cta-note{display:flex;align-items:center;justify-content:center;gap:10px;font-size:.85rem;color:rgba(255,255,255,.5);flex-wrap:wrap}
.sol-is-hotel .cta-note .dot{width:5px;height:5px;background:rgba(255,255,255,.3);border-radius:50%}

/* ===== Footer (对齐 zjssoft.com 框选底部区域) ===== */

/* ===== Scroll Animations ===== */
.sol-is-hotel .reveal{opacity:0;transform:translateY(32px);transition:opacity .8s ease,transform .8s ease}
.sol-is-hotel .reveal.active{opacity:1;transform:translateY(0)}
.sol-is-hotel .reveal-delay-1{transition-delay:.12s}
.sol-is-hotel .reveal-delay-2{transition-delay:.24s}
.sol-is-hotel .reveal-delay-3{transition-delay:.36s}

/* ===== Mobile Responsive ===== */
@media(max-width:1024px){
  .sol-is-hotel .hero-grid{grid-template-columns:1fr;gap:48px}
  .sol-is-hotel .hero h1{font-size:2.6rem}
  .sol-is-hotel .pain-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-hotel .solution-grid{grid-template-columns:1fr}
  .sol-is-hotel .func-grid{grid-template-columns:1fr}
  .sol-is-hotel .advantage-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-hotel .advantage-card.featured{grid-column:span 2}
  .sol-is-hotel .scenario-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-hotel .value-grid{grid-template-columns:repeat(2,1fr)}
  .sol-is-hotel .trust-stats{grid-template-columns:repeat(2,1fr)}
  .sol-is-hotel .logo-grid{grid-template-columns:repeat(3,1fr)}
}
@media(max-width:768px){
  .sol-is-hotel .section{padding:72px 0}
  .sol-is-hotel .section-title{font-size:1.8rem}
  .sol-is-hotel .section-head{margin-bottom:42px}
  .sol-is-hotel .hero{padding:72px 0 64px}
  .sol-is-hotel .hero h1{font-size:2.1rem}
  .sol-is-hotel .hero-sub{font-size:1.05rem}
  .sol-is-hotel .hero-cta{flex-direction:column;width:100%}
  .sol-is-hotel .hero-cta .btn{width:100%}
  .sol-is-hotel .hero-trust{gap:20px}
  .sol-is-hotel .hero-trust-divider{display:none}
  .sol-is-hotel .hero-trust-num{font-size:1.4rem}
  .sol-is-hotel .hero-trust-label{font-size:.78rem}
  .sol-is-hotel .hero-visual{max-width:440px;margin:0 auto}
  .sol-is-hotel .dash-float{display:none}
  .sol-is-hotel .pain-grid{grid-template-columns:1fr;gap:18px}
  .sol-is-hotel .pain-card{padding:30px 24px}
  .sol-is-hotel .func-card{padding:28px 24px;flex-direction:column;gap:16px}
  .sol-is-hotel .func-card-num{font-size:2rem;min-width:auto}
  .sol-is-hotel .advantage-grid{grid-template-columns:1fr}
  .sol-is-hotel .advantage-card.featured{grid-column:span 1}
  .sol-is-hotel .scenario-grid{grid-template-columns:1fr}
  .sol-is-hotel .value-grid{grid-template-columns:1fr 1fr}
  .sol-is-hotel .trust-stats{grid-template-columns:1fr 1fr;gap:14px}
  .sol-is-hotel .trust-stat{padding:24px 14px}
  .sol-is-hotel .trust-stat .num{font-size:2.1rem}
  .sol-is-hotel .logo-wall{padding:28px}
  .sol-is-hotel .logo-grid{grid-template-columns:repeat(2,1fr);gap:14px}
  .sol-is-hotel .logo-item{height:54px;font-size:.75rem}
  .sol-is-hotel .trust-cert{grid-template-columns:1fr;gap:14px}
  .sol-is-hotel .cert-card{padding:20px}
  .sol-is-hotel .cta-inner h2{font-size:1.9rem}
  .sol-is-hotel .cta-inner p{font-size:1rem}
  .sol-is-hotel .cta-options{flex-direction:column;width:100%}
  .sol-is-hotel .cta-options .btn{width:100%}
}
@media(max-width:480px){
  .sol-is-hotel .container{padding:0 18px}
  .sol-is-hotel .hero h1{font-size:1.85rem}
  .sol-is-hotel .section-title{font-size:1.55rem}
  .sol-is-hotel .dash-stats{grid-template-columns:1fr;gap:8px}
  .sol-is-hotel .value-grid{grid-template-columns:1fr}
}

/* 业务架构图（参考模版） */
/* 新零售全域业务架构图 */
.sol-is-hotel .ai-architecture{padding:34px!important;margin-top:46px!important;border:1px solid #d5e6f8!important;border-radius:20px!important;background:#f8fbff!important;box-shadow:0 16px 36px rgba(13,71,161,.08)!important}.ai-architecture h3{font-size:1.48rem!important;color:#102e52!important;text-align:center!important}.ai-architecture>p{max-width:700px;margin:0 auto 28px!important;text-align:center!important;line-height:1.7}.arch-map{display:grid;gap:13px}.arch-band{display:grid;grid-template-columns:174px 1fr;gap:13px;align-items:stretch}.arch-band-label{padding:16px;border-radius:12px;display:flex;flex-direction:column;justify-content:center;background:#e6f1ff;color:#125aa5;font-size:.92rem;font-weight:800}.arch-band-label small{margin-top:5px;color:#5f87b4;font-size:.68rem;font-weight:500}.arch-band-content{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:10px}.arch-unit{min-height:84px;padding:13px 9px;border:1px solid #d4e5f8;border-radius:11px;background:#fff;text-align:center;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#143b68;font-size:.82rem;font-weight:800;transition:transform .2s,box-shadow .2s}.arch-unit:hover{transform:translateY(-3px);box-shadow:0 7px 16px rgba(30,136,229,.12)}.arch-unit i{display:grid;place-items:center;width:24px;height:24px;margin-bottom:6px;border-radius:7px;background:#e5f1ff;color:#1565c0;font-size:.72rem;font-style:normal}.arch-unit small{display:block;color:#7088a3;font-size:.66rem;font-weight:400;line-height:1.35;margin-top:4px}.arch-band.core .arch-band-label{background:#0d47a1;color:#fff}.arch-band.core .arch-band-label small{color:#c6e1ff}.arch-band.core .arch-unit{background:#1565c0;border-color:#1565c0;color:#fff}.arch-band.core .arch-unit i{background:#fff;color:#1565c0}.arch-band.core .arch-unit small{color:#d6eaff}.arch-band.ai .arch-band-label{background:#e8f3ff}.arch-band.ai .arch-unit{border-color:#b9d9fa;background:#fafdff}.arch-map-note{display:flex;align-items:center;justify-content:center;gap:9px;margin-top:20px;padding-top:16px;border-top:1px dashed #c9ddf2;color:#62809f;font-size:.77rem}.arch-map-note b{color:#1565c0}@media(max-width:1100px){.arch-band-content{grid-template-columns:repeat(3,minmax(0,1fr))}}@media(max-width:700px){.ai-architecture{padding:21px!important}.arch-band{grid-template-columns:1fr}.arch-band-label{padding:12px;align-items:center;text-align:center}.arch-band-content{grid-template-columns:repeat(2,minmax(0,1fr))}.arch-unit{min-height:78px}.arch-map-note{align-items:flex-start;flex-direction:column}}
</style>
